import React from 'react';
import PropTypes from 'prop-types';
import ContentEditable from 'react-contenteditable';

function TextEditable({ children, setContent, disabled, tagName = 'span' }) {
    return (
        <ContentEditable
            html={children}
            disabled={disabled}
            onChange={(e) => setContent(e.target.value)}
            tagName={tagName}
        />
    );
}

TextEditable.propTypes = {
    children: PropTypes.string.isRequired,
    setContent: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    tagName: PropTypes.string,
};

TextEditable.defaultProps = {
    disabled: false,
    tagName: 'span',
};

export default React.memo(TextEditable);
